import styled from 'styled-components';

/**
 * The design's `.add-divider`.
 *
 * It replaces `components/lineWrappedComponent`, which drew two 20%-opacity
 * grey bars around a peach `#f6e6e0` pill — a colour on no palette, for the
 * one control on the screen that adds something.
 *
 * The button is styled from here rather than at the call site so the four
 * repeatable sections in the product cannot drift apart again. It is the
 * design's secondary button with primary ink: quiet at rest, and clearly the
 * add affordance under the pointer.
 */
export const AddDivider = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s4);
  margin: var(--s2) 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--line);
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--s2);
    height: var(--h-btn-sm);
    padding: 0 var(--s3);
    border: 1px solid var(--line-strong);
    border-radius: var(--r-sm);
    background: var(--surface);
    font-family: var(--font-ui);
    font-size: var(--fs-label);
    font-weight: var(--fw-medium);
    line-height: 1;
    white-space: nowrap;
    color: var(--primary);
    cursor: pointer;
    transition:
      background-color 0.12s,
      border-color 0.12s;

    &:hover:not(:disabled) {
      background: var(--primary-soft);
      border-color: var(--primary);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
      color: var(--text-muted);
    }

    svg {
      width: 15px;
      height: 15px;
      stroke-width: 1.9;
    }
  }
`;
